import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import { MenuButton, MenuOption } from '../foundation/shared/components/menu';
import { router } from './router';
import { useLogout } from '@client/features/auth/logout.hook';

export const Account = () => {
  const logout = useLogout();

  const menuOptions: MenuOption[] = [
    {
      label: 'Logout',
      onClick: logout
    },
    { label: 'Settings', onClick: () => router.navigate('/settings') }
  ];

  return (
    <Box>
      <MenuButton
        options={menuOptions}
        menuIcon={
          <Avatar
            alt="User"
            src=""
            sx={{
              width: 30,
              height: 30,
              border: '1px solid var(--ds-button-secondary-border)',
              background: 'var(--ds-button-secondary-gradient)',
              color: 'var(--ds-button-secondary-text)'
            }}
          />
        }
      />
    </Box>
  );
};
